import { Suspense, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import type { EmailTemplateDto } from "@babackapp/private-api-client/types";
import { ReturnTemplatesProvider } from "@babackapp/templates-editor/return-provider";
import { ReturnTemplatesList } from "@babackapp/templates-editor/return-templates-list";
import { NotificationTemplatePreview } from "@babackapp/templates-editor/notification-template-preview";
import { RETURN_PREVIEW_VARIABLES } from "@babackapp/templates-editor/return-variables";
import { Separator } from "@babackapp/ui/components/separator";

export default function ReturnEmailTemplatesListPage() {
  const { shopId } = useParams<{ shopId: string }>();
  const navigate = useNavigate();
  const [hoveredTemplate, setHoveredTemplate] =
    useState<EmailTemplateDto | null>(null);

  if (!shopId) return null;

  return (
    <Suspense fallback={null}>
      <ReturnTemplatesProvider
        shopId={shopId}
        openTemplate={(id) =>
          navigate(`/shops/${shopId}/settings/notifications/email-templates/${id}`)
        }
      >
        <div className="absolute inset-0 flex items-center justify-center p-8">
          <div className="w-full h-full max-w-5xl rounded-md border p-4 flex flex-col">
            <div className="flex flex-1 min-h-0 gap-4">
              <div className="w-sm min-h-0 flex flex-col">
                <ReturnTemplatesList onTemplateHover={setHoveredTemplate} />
              </div>
              <Separator orientation="vertical" />
              <div className="flex-1 min-h-0">
                <NotificationTemplatePreview
                  template={hoveredTemplate}
                  variables={RETURN_PREVIEW_VARIABLES}
                />
              </div>
            </div>
          </div>
        </div>
      </ReturnTemplatesProvider>
    </Suspense>
  );
}
